var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{class:['powered-by-footer', { 'has-bottom-nav': _vm.bottomNav }]},[_c('span',[_vm._v("Powered by")]),_c('img',{attrs:{"src":_vm.logo,"alt":"Mazzitech"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }